import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import StartScreen from './components/StartScreen';
import Game from './components/Game';
import { Homepage, Games, Tokenomics, Buy, Stake, Validator, Memecollection, WhyReddicks, TreasuryPage, Charity } from './components/Home';
import { RadixConnectProvider } from './radix_connect';
import { dAppDefinitionAddress } from './constants';
import './styles/App.scss';
import ScrollToTop from './components/Common/ScrollToTop';
import ImageDirectPage from './components/Common/HomepageCard/ImageDirectPage';


const App = () => {
  return (
    <RadixConnectProvider dAppDefinitionAddress={dAppDefinitionAddress}>
      <Router>
        <ScrollToTop />
        <div className="app-container">
          <div className="app">
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/game-info" element={<Games />} />
              <Route path="/tokenomics" element={<Tokenomics />} />
              <Route path="/buy" element={<Buy />} />
              <Route path="/start" element={<StartScreen />} />
              <Route path="/game/:saveId" element={<Game />} />
              <Route path="/stake" element={<Stake />} />
              <Route path="/validator" element={<Validator />} />
              <Route path="/memecollection" element={<Memecollection />} />
              <Route path="/whyreddicks" element={<WhyReddicks />} />
              <Route path="/charity" element={<Charity />} />
              <Route path="/treasury" element={<TreasuryPage />} />
              <Route path="/live-card" element={<ImageDirectPage />} />
              <Route path="/live-card/card.png" element={<ImageDirectPage />} />
              <Route 
                path="/.well-known/radix.json" 
                element={<Navigate to={`${process.env.PUBLIC_URL}/.well-known/radix.json`} replace />} 
              />
            </Routes>
          </div>
        </div>
      </Router>
    </RadixConnectProvider>
  );
};

export default App;